var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.events.length)?_c('super-container-view',[_c('back'),_c('campaign-selector',{attrs:{"resourcePath":"campaigns","hiCampaignSelected":_vm.hiCampaignSelected}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }